<template>
  <div  style="position: absolute;left: 0; top: 0; background-color: #f3f3f3; z-index: 1500;">
    <div class="d-flex align-items-center justify-content-center" id="cont_main">
      <div class="wraper col-md-8 col-sm-12">
        <div class="logo-wraper ">
            <div class="logo d-flex align-items-center justify-content-center ">
              <img style="max-width: 30%; min-width: 30%;" src="../assets/pictures/me_big.png" alt="branding logo" @click="$router.push({ name: 'login'});">
            </div>
        </div>        
        <div class="form-wraper d-flex align-items-center justify-content-center" >
          <div class="form-content col-md-12">
              <div>
                <div class="lang-swicher">
                  <ul class="nav navbar-nav float-xs-right"> 
                    <li class="dropdown dropdown-language nav-item">
                    <a id="dropdown-flag" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="dropdown-toggle nav-link">
                      <!-- <i ref="lang_btn" class="flag-icon" :class="$i18n.tc('lang.logo', $i18n.locale )"></i> -->
                      <span class="selected-language"> {{$i18n.tc('lang.titleS', $i18n.locale )}}</span>
                    </a>                
                    <div aria-labelledby="dropdown-flag" class="dropdown-menu">
                      <a class="dropdown-item" @click="changeLanguage('ua')">UA </a>
                      <a class="dropdown-item" @click="changeLanguage('pl')">Pl</a>
                      <a class="dropdown-item" @click="changeLanguage('en')">EN </a>                  
                      <a class="dropdown-item" @click="changeLanguage('ru')">RU</a>
                      
                    </div>
                  </li>
                  </ul>
                </div>

                <div class="title my-2">
                  <h3>{{$t('registr.btn.regAs')}}  
                    <select v-model="registerType" class="register-type">                    
                    <option selected value="1">{{$t('registr.type.1')}}</option>
                    <option value="2">{{$t('registr.type.2')}}</option>
                    <option value="3">{{$t('registr.type.3')}}</option>
                  </select>
                  </h3>
                </div>


              </div>
              
              <div class="login-form ">
                <register-as-delivery :type="registerType"></register-as-delivery>
              </div>
              <div class="register mb-3 d-flex justify-content-center mt-2">                 
                  <span class="mr-2 my-1">{{ $t('registr.lbl.existing') }}?</span><button type="button" class="btn btn-outline-secondary btn-md" @click="$router.push({name: 'login'})">{{ $t('login.btn.login') }}</button>
                </div>            
          </div>          
        </div>
      </div>   
    </div>
  </div>
</template>

<script>
// import registerAsClient from '../components/forms/registerAsClient'
import registerAsDelivery from '../components/forms/registerAsDelivery'

    export default {
      name: "LoginNew",
      components: {registerAsDelivery},
      data() {
          return { 
            role:"",
            register: false, 
            registerType:"1",
            registerAsClient:false,          
            image: {name: null, data: null},
            errors: [],
            error:{
              directionOfdelivery: false,
              typeOfdelivery:false
            },
            submitStatus:null,
            
          }
        },
    
        methods: {
          success(data){
            console.log(data);
            this.register = false;
            this.registerType = null;
          },
            setRegisterType(type){
                this.registerType = type;
            },  
          onUploadImg(e){
            if (e.target.files.length > 0){
              for (let i = 0; i < e.target.files.length; i++) {
                const element = e.target.files[i];
                const reader = new FileReader();
                reader.readAsDataURL(element);
                reader.onload = e => {
                  //this.images.push({name: element.name, data: e.target.result});
                  this.image = {name: element.name, data: e.target.result};
                };                        
              }
            }
          },          
         
        },
        computed:{
                     },
        watch:{},
        mounted () {
       
        }
    }
</script>

<style scoped>

.img_cont{
  max-width: 40%;
}
  #cont_main{
  background-image: url('../assets/pictures/bagr.jpg');
  background-color: rgba(255,255,255,0.5); 
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-attachment: fixed;
  width: 100vw;
  min-height: 100vh;
}

.form-wraper {
  background: #E5E5DB;
  width: 100%;  
}
.form-wraper .title {
  text-align: center;
}
.title h3 {
  font-weight: bold;
  font-size: 40px;
}
.title h3 option {
  font-size: 20px;
}

.selected-language {
    padding: 5px 5px;
    border: 1px solid #000;
}
.dropdown .dropdown-menu {
    min-width: 40px;
    background: #000;
    color: #fff;
}
.dropdown-item {
    color: #fff;
}
.dropdown-item:hover {
    color: #000;
}
a:not([href]):not([tabindex]):hover {
    color: #000;
}
.logo {
  margin-bottom: 40px;
   cursor: pointer;
}
.card-block {
  padding: 10px;
}
.form-control, .form-control-lg {
font-size: 1rem !important;
}
.btn-outline-secondary:hover {
  background-color: #000
}
.register-type {
  background: #E5E5DB;
  border: none;
}
@media only screen and (max-width: 800px) {
.inn {
   padding-left: 0px;
}
.ex-btn {
  display: block;
}
.title h3 { 
  font-size: 18px;
}
}
</style>


// WEBPACK FOOTER //
// src/pages/Register.vue